import './OfficeLocation.css';

export default function OfficeLocation() {
  return (
    <div className="office-location-section">
      <div className="office-container">

        <div className="office-header">
          <p className="office-eyebrow">Our Location</p>
          <h2 className="office-title">Watt &amp; Wattle Office</h2>
          <p className="office-subtitle">Our team is here to help. Get in touch with us today.</p>
        </div>

        <div className="office-content">
          {/* Left — Map */}
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.5146645276927!2d145.19345417589346!3d-37.988454271932326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad6135bc615dbbb%3A0xf0be61af24ff29ad!2sWatt%20%26%20Wattle%20-%20Solar%20Panels%20%26%20Batteries!5e0!3m2!1sen!2sin!4v1790074173423!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              title="Watt & Wattle Location"
            />
          </div>

          {/* Right — Info card */}
          <div className="office-info-card">
            <h3 className="office-city">Melbourne, Australia</h3>

            <div className="info-items">
              <div className="info-item">
                <div className="info-icon-wrap">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="#050b14" strokeWidth="2" />
                    <path d="M12 7v5l3 3" stroke="#050b14" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <span>Monday – Friday: 9am – 5pm</span>
              </div>

              <div className="info-item">
                <div className="info-icon-wrap">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="#050b14" strokeWidth="2" />
                    <circle cx="12" cy="9" r="2.5" stroke="#050b14" strokeWidth="2" />
                  </svg>
                </div>
                <span>1 Wayne Court, Dandenong VIC 3175</span>
              </div>

              <div className="info-item">
                <div className="info-icon-wrap">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#050b14" />
                  </svg>
                </div>
                <a href="mailto:sales@wattandwattle.com.au">sales@wattandwattle.com.au</a>
              </div>

              <div className="info-item">
                <div className="info-icon-wrap">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" fill="#050b14" />
                  </svg>
                </div>
                <a
                  href="tel:0414339191"
                  onClick={(e) => {
                    if (typeof window.gtag_phone_report_conversion === 'function') {
                      window.gtag_phone_report_conversion('tel:0414339191');
                    }
                  }}
                >
                  0414 339 191
                </a>
              </div>
            </div>

            <a
              href="tel:0414339191"
              className="office-cta-btn"
              onClick={(e) => {
                if (typeof window.gtag_phone_report_conversion === 'function') {
                  window.gtag_phone_report_conversion('tel:0414339191');
                }
              }}
            >
              Call us now
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="#050b14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}
